export { default as AcademyLayout } from './AcademyLayout';
export { default as FillLayout } from './FillLayout';
export { default as HintLayout } from './HintLayout';
export { default as LoadingLayout } from './LoadingLayout';
export { default as RedirectLayout } from './RedirectLayout';
export { default as SuspenseLayout } from './SuspenseLayout';
